/**
 * @file   琴书阁
 * @create macaiqi 2025/04/28
 * @update
 */
import React, { useState, useRef, useEffect } from "react";
import cls from "classnames";
import mxq from "../../assets/images/mxq.png";
import readshade from "../../assets/images/readshade.png";
import TalkShade from "./talkShade";
import GoSecond from "./goSecond";
import Legend from "./Legend";
import QNQSHome from "./QNQS";
import QNQS from "./QNQS/QNQS";
import img2 from "../../assets/images/qsgpage2.jpg";
import img3 from "../../assets/images/qsgpage3.jpg";
import img1 from "../../assets/images/qsgpage1.jpg";
// import $ from "jquery";
import "../Home/home.scss";
import "./index.scss";

export default function QSG({ setToPage }) {
  let floor = ["三层", "二层", "首层"];
  const [floorAt, setFloorAt] = useState(2); //0三层 1二层 2首层
  const [show, setShow] = useState();

  // ************切换楼层流光效果********************
  const [start, setstart] = useState(2); // 切换楼层的特效用
  const floorRefs = useRef([]);
  useEffect(() => {
    setstart(floorAt);
  }, [floorAt]);
  // // 添加 ref 到每个楼层项
  // useEffect(() => {
  //   floorRefs.current = floorRefs.current.slice(0, floor.length);
  // }, [floor.length]);

  // // 计算两点之间的连线
  // const drawLine = (startPoint, endPoint, reverse) => {
  //   let lineh = 120;
  //   const line = $("<div>")
  //     .addClass("flow-line")
  //     .css({
  //       position: "absolute",
  //       height: lineh + "px",
  //       width: "4px",
  //       background: reverse
  //         ? "linear-gradient(to top, transparent, #ffd52e)"
  //         : "linear-gradient(to bottom, transparent, #ffd52e)",
  //       left: startPoint.x - 2,
  //       top: reverse ? startPoint.y - lineh : startPoint.y,
  //     });

  //   $(".qsg-page").append(line);

  //   // 动画效果
  //   line.animate(
  //     {
  //       top: reverse ? endPoint.y : endPoint.y - lineh,
  //     },
  //     600,
  //     () => {
  //       line.remove();
  //     }
  //   );
  // };

  // 处理楼层切换
  const handleFloorChange = (index) => {
    if (index !== floorAt) {
      // // 延迟执行以确保 DOM 已更新
      // setTimeout(() => {
      //   const startPoint = $(".qsg-page .item").eq(start).find("i").offset();
      //   const endPoint = $(".qsg-page .item").eq(index).find("i").offset();
      //   let reverse = index < start;
      //   drawLine(
      //     {
      //       x: startPoint.left / 2 + 8 - $(".qsg-page").offset().left,
      //       y: startPoint.top / 2 + 8 - $(".qsg-page").offset().top,
      //     },
      //     {
      //       x: endPoint.left / 2 + 8 - $(".qsg-page").offset().left,
      //       y: endPoint.top / 2 + 8 - $(".qsg-page").offset().top,
      //     },
      //     reverse
      //   );
      // }, 50);
      setTimeout(() => {
        setFloorAt(index);
      }, 300);
    }
  };
  // ************切换楼层流光效果结束********************

  return (
    <div className="common-page qsg-page  animate__animated animate__fadeIn animate__faster ">
      <div
        className="back"
        onClick={() => {
          setToPage();
        }}
      ></div>
      <div className="floor">
        {floor.map((item, index) => {
          return (
            <div
              ref={(el) => (floorRefs.current[index] = el)}
              className={cls("item", { active: index === floorAt })}
              key={index}
              onClick={() => {
                handleFloorChange(index);
              }}
            >
              {item}
              <i></i>
            </div>
          );
        })}
      </div>
      <div className="imgbox ">
        {floorAt === 2 && (
          <div className="onefloor">
            <img
              src={img1}
              alt=""
              className="bg animate__animated animate__fadeIn"
            />
            <div
              className="talk animate__animated animate__pulse animate__slower	 animate__infinite"
              onClick={() => {
                setShow("talk");
              }}
            ></div>
            <div
              className="tosecend"
              onClick={() => {
                handleFloorChange(1);
                // setShow("gosecond");
              }}
            ></div>
            {/* 对话 */}
            {show === "talk" && <TalkShade setShow={setShow} />}
            {/* 没兴趣 */}
            {show === "mxq" && (
              <div className="shade mxq">
                <i
                  className="back"
                  onClick={() => {
                    setShow();
                  }}
                ></i>
                <img src={mxq} alt="" />
              </div>
            )}
            {/*  传说*/}
            {show === "gq" && <Legend setShow={setShow} />}

            {/* 去二楼 */}
            {show === "gosecond" && (
              <GoSecond
                setShow={setShow}
                handleFloorChange={handleFloorChange}
              />
            )}
          </div>
        )}
        {floorAt === 1 && (
          <div className="secondfloor ">
            <img
              src={img2}
              alt=""
              className="bg animate__animated animate__fadeIn"
            />
            {/* 前年琴史 */}
            <div
              className="common-hot"
              onClick={() => {
                setShow("qnqshome");
              }}
            ></div>
            {show === "qnqshome" && <QNQSHome setShow={setShow} />}
            {show?.includes("qnqscontent") && (
              <QNQS setShow={setShow} show={show} />
            )}
            <div
              className="go1"
              onClick={() => {
                handleFloorChange(2);
              }}
            ></div>
            <div
              className="go3"
              onClick={() => {
                handleFloorChange(0);
              }}
            ></div>
          </div>
        )}
        {floorAt === 0 && (
          <div className="thirdfloor">
            <img
              src={img3}
              alt=""
              className="bg animate__animated animate__fadeIn"
            />
            <i
              className="shu"
              onClick={() => {
                setShow("read");
              }}
            ></i>
            <i
              className="go2"
              onClick={() => {
                handleFloorChange(1);
              }}
            ></i>
            {show === "read" && (
              <div className="shade shade-read">
                <img src={readshade} alt="" />
                <div
                  className="close"
                  onClick={() => {
                    setShow();
                  }}
                ></div>
                <div
                  className="btn"
                  onClick={() => {
                    // window.location.href = "/Book/index.html";
                    setShow("book");
                  }}
                ></div>
              </div>
            )}
            {show === "book" && (
              <div className="common-page">
                <iframe src="/Book/index.html" title="book" frameBorder={0} />

                <div
                  className="iframeclose"
                  onClick={() => {
                    setShow();
                  }}
                ></div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
